import { View } from "react-native"
import { Body, H4, H5, Tiny } from "@/components/standard/BFText"
import React, { useEffect } from "react"
import { loanPerkViewed } from "@/analytics/events/loans"
import { useLoanContext } from "@/screens/loans/components/LoanContext"
import Megaphone from "@/assets/clipart/techny-small-megaphone.svg"
import { LevelDiscount } from "@/screens/rewards/components/LevelDiscount"
import { Vertical } from "@/components/standard/BFLayout"
import { TimeBasedOriginationDiscount } from "@/screens/loans/components/TimeBasedOriginationDiscount"

export const AvailableDiscountsSections = () => {
  const { loanApplication } = useLoanContext()

  const { cashToCloseDisplaysAsRange } = useLoanContext()

  useEffect(() => {
    if (loanApplication?.isPerkQualified) {
      loanPerkViewed()
    }
  }, [loanApplication])

  if (
    !loanApplication?.isPerkQualified &&
    !loanApplication.rewardsTier &&
    !(!loanApplication.discounts || loanApplication.discounts.length === 0)
  ) {
    // No rewards to show, hide entire section.
    return null
  }

  return (
    <View
      className={`${cashToCloseDisplaysAsRange ? "mt-4" : ""} px-4 py-2 grow`}
    >
      {loanApplication?.isPerkQualified && (
        <View className="flex mb-2">
          <H4 className="text-midnight-blue">Available Discounts</H4>
        </View>
      )}

      <Vertical className={"gap-2"}>
        {loanApplication?.isPerkQualified && (
          <View className="flex flex-row items-center rounded-md pl-3 bg-teal border border-warm-grey">
            <View className="flex items-center justify-center w-[48px]">
              <Megaphone width={42} height={42} />
            </View>
            <View className="flex items-start pt-4 pl-3 mb-4">
              <H5 className="text-midnight-blue">BACKFLIP PERK ALERT!</H5>
              <Body className="text-midnight-blue">
                This deal may qualify for special rates.*
              </Body>
            </View>
          </View>
        )}

        {loanApplication?.rewardsTier && (
          <LevelDiscount
            className={"bg-grey"}
            // @ts-expect-error graphql type problem
            level={loanApplication.rewardsTier}
            postFix={"**"}
          />
        )}
      </Vertical>

      {loanApplication?.isPerkQualified && (
        <Tiny className={"text-midnight-blue mt-1"}>
          *Eligibility is based on self-reported information. Loan approval is
          subject to verification of qualifications. Terms and conditions apply.
        </Tiny>
      )}

      {loanApplication?.rewardsTier && (
        <Tiny className={"text-midnight-blue"}>
          **Fee discounts are automatically applied and reflected in estimates
          below.
        </Tiny>
      )}

      <TimeBasedOriginationDiscount />
    </View>
  )
}
